import BaseApp from "@/modules/base-app";
import JobbersSeoSearchBar from "../pages/jobbers-seo-search-bar";
import ErrorBoundary from "../utils/error-boundary";

const JobbersSeoSearchBarApp = (props) => {
  const updateUrlParams = (values) => {
    const urlParams = new URLSearchParams(window.location.search);
    Object.keys(values).forEach((key) => {
      if (values[key]) {
        urlParams.set(key, values[key]);
      } else {
        urlParams.delete(key);
      }
    });
    window.location.href = `/jobbers?${urlParams.toString()}`;
  };

  const handleSubmit = (values) => {
    updateUrlParams(values);
  };

  return (
    <ErrorBoundary>
      <BaseApp>
        <JobbersSeoSearchBar initialValues={props.initial_values} onSubmit={handleSubmit} />
      </BaseApp>
    </ErrorBoundary>
  );
};

export default JobbersSeoSearchBarApp;
